import _flowRight from 'lodash/flowRight';
import _unionBy from 'lodash/unionBy';
import { normalize } from 'normalizr';
import { uploadAsset, deleteAsset } from '@homeservices/api-kit/asset';
import { getJobFiles } from '@homeservices/api-kit/proreferral/files/v2';

import http from '@homeservices/api-kit/axios';
import { JOBS_SCHEMA } from '@/store/modules/entities';
import { toSnakeCase } from '@/utils/to-snake-case';
import { withRequestLifecycle, REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';

const MUTATION_KEY = 'patchFiles';

const emptyArray = [];

const extractFilesFromJob = (jobId, entities) => {
  const [matchId] = entities.jobs[jobId].matches;

  return entities.matches[matchId].files;
};
const reconcileFilesWithinJob = (jobId, skillsProfile, entities, files, strategy) => {
  const oldFiles = extractFilesFromJob(jobId, entities) || emptyArray;

  return {
    id: jobId,
    matches: [
      {
        skills_profile: skillsProfile,
        files: strategy(oldFiles, files),
      },
    ],
  };
};
const addStrategy = (oldEntities, newEntitiesToAdd) =>
  _unionBy(oldEntities, newEntitiesToAdd, maybeEntity => maybeEntity.id || maybeEntity);
export default {
  state: {
    current: {
      status: REQUEST_LIFECYCLE.UNINITIALIZED,
      error: null,
      result: emptyArray,
      count: 0,
      total: 0,
      hasMore: false,
    },
  },
  getters: {
    currentJobFilesMeta: (state) => {
      const { result, ...meta } = state.current;

      return meta;
    },
    currentRawJobFiles: state => state.current.result,
  },
  actions: {
    // TODO: The fetch files action and it's implementation can be removed post migration
    fetchFiles: _flowRight(withRequestLifecycle(MUTATION_KEY))(
      async (
        { rootState: { entities: oldEntities } },
        { injected: { performFulfillment }, jobId, skillsProfile, params = {} }
      ) => {
        const { data } = await getJobFiles(jobId, toSnakeCase(params));
        const { entities } = normalize(
          reconcileFilesWithinJob(jobId, skillsProfile, oldEntities, data.results, addStrategy),
          JOBS_SCHEMA
        );
        performFulfillment({
          entities,
          result: extractFilesFromJob(jobId, entities),
          total: data.total,
        });

        return data;
      }
    ),
    createFiles: _flowRight(withRequestLifecycle(MUTATION_KEY))(
      async (
        context,
        { jobId, body }
      ) => {
        const { data } = await uploadAsset('work-orders-private-msg', `${jobId}`, body);
        const { data: { results: [result] } } = await http.get(`/platform/coreassets/r/assets/images/v1?url=${data.url}`);
        data.id = [result.id];
        return data;
      }
    ),
    deleteFiles: _flowRight(withRequestLifecycle(MUTATION_KEY))(
      async (
        context,
        { fileId }
      ) => {
        await deleteAsset('work-orders-private-msg', fileId);
      }
    ),
    resetCurrentFilesError: ({ commit }) => commit('resetCurrentFilesError'),
  },
  mutations: {
    [MUTATION_KEY] (state, payload) {
      const { result } = payload;
      let {
        count = state.current.count,
        total = state.current.total,
        hasMore = state.current.hasMore,
      } = payload;

      if (result) {
        const diff = payload.result.length - state.current.result.length;

        count = result.length;
        total = state.current.total + diff;
        hasMore = result.length < total;
      }

      state.current = {
        ...state.current,
        ...payload,
        count,
        total,
        hasMore,
      };
    },
    resetCurrentFilesError (state) {
      state.current.error = null;
    },
  },
};
